import 'css-chunksrc/client/scenes/moveFolder/folderSelection/folder/styles.scss';export default {
  "projectIcon": "_projectIcon_jk5ty_1",
  "folderIcon": "_folderIcon_jk5ty_7",
  "name": "_name_jk5ty_12",
  "selected": "_selected_jk5ty_24"
};